function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  transform: "translate(-727 -4665) translate(0 4345) translate(340 130) translate(0 178)"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  transform: "translate(340) translate(47 12) translate(15 17)"
}, React.createElement("rect", {
  width: 6.12,
  height: 23.4,
  x: -.18,
  y: -.9,
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.8,
  rx: 1.44
}), React.createElement("rect", {
  width: 17.64,
  height: 23.4,
  x: 9.54,
  y: -.9,
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.8,
  rx: 1.44
}), React.createElement("circle", {
  cx: 21.96,
  cy: 4.32,
  r: 2.16,
  fill: "currentColor"
}), React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.8,
  d: "M0 10.138l2.203-1.97c.866-.775 1.938-1.29 3.077-1.54m4.635.452c.44.195.86.438 1.252.726l6.167 4.558c2.592 1.916 6.527 1.69 8.789-.507.346-.337.641-.71.877-1.11"
})))))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/image-grid.c09f4960.svg";
export { SvgComponent as ReactComponent };